/// <reference path="../../../scripts/typings/googlemaps/google.maps.d.ts" />
/// <reference path="../../../scripts/typings/jquery/jquery.d.ts" />

let franchiseMap: google.maps.Map | null = null;
let franchiseInfoWindow: google.maps.InfoWindow | null = null;

type FranchiseMapFeatureProperties = {
    color?: string;
    franchiseId?: number;
    isDisabled?: boolean;
    name?: string;
    regionUrl?: string;
    subRegionUrl?: string;
    url?: string;
};


const style: any = [
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": 0
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#ffffff"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#ffffff"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 100
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#ffffff"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 100
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": 0
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#bbbbbb"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 26
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#dddddd"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -3
            },
            {
                "visibility": "on"
            }
        ]
    }
];
function setupFranchiseMap()
{
    const map = jQuery("[data-gmap-geojson]");
    if (map.length === 0)
    {
        return;
    }

    franchiseMap = new google.maps.Map(map[0], {
        center: new google.maps.LatLng(54.237933, -2.36967),
        zoom: 5,
        styles: style
    });

    franchiseInfoWindow = new google.maps.InfoWindow();

    franchiseMap.data.setStyle(function (feature)
    {
        const color = feature.getProperty("color") || "#002653";

        return {
            clickable: true,
            fillColor: color,
            fillOpacity: 0.37,
            strokeColor: color,
            strokeOpacity: 0.81,
            strokeWeight: 2
        };
    });

    franchiseMap.data.loadGeoJson(map.data("gmap-geojson"), undefined, function (features)
    {
        if (!franchiseMap || features.length === 0)
        {
            return;
        }

        const bounds = new google.maps.LatLngBounds();

        features.forEach(function (feature)
        {
            const geometry = feature.getGeometry();
            if (geometry)
            {
                extendBoundsForGeometry(bounds, geometry);
            }
        });

        if (!bounds.isEmpty())
        {
            franchiseMap.fitBounds(bounds);
        }
    });

    franchiseMap.data.addListener("click", function (event)
    {
        const props = getFeatureProperties(event.feature);
        const infoWindowHtml = getInfoWindowHtml(props);
        if (!infoWindowHtml || !franchiseInfoWindow)
        {
            return;
        }

        franchiseInfoWindow.setContent(infoWindowHtml);
        franchiseInfoWindow.setPosition(event.latLng);
        franchiseInfoWindow.open(franchiseMap || undefined);
    });

    function searchPostcodes()
    {
        let postcode = jQuery(".region-search input").val();
        if (!postcode)
        {
            jQuery(".region-franchise").show();
            return;
        }

        postcode = postcode.trim();
        if (postcode.length === 0)
        {
            jQuery(".region-franchise").show();
            return;
        }

        postcode = postcode.toUpperCase();

        const regex = /^([A-Z]{1,2}\d[A-Z0-9]?)( ?\d[A-Z]{2}| \d)$/;
        const regexResult = regex.exec(postcode);
        if (regexResult && regexResult.length >= 2)
        {
            postcode = regexResult[1];
        }

        jQuery(".region-franchise").each(function (_, elem)
        {
            const data = jQuery(elem).data("postcodes");
            if (Array.isArray(data) && data.indexOf(postcode) !== -1)
            {
                jQuery(elem).show();
            }
            else
            {
                jQuery(elem).hide();
            }
        });
    }

    jQuery(".region-search input").change(searchPostcodes);
    jQuery(".region-search input").keyup(searchPostcodes);
}

function extendBoundsForGeometry(bounds: google.maps.LatLngBounds, geometry: google.maps.Data.Geometry)
{
    const geometryType = geometry.getType();

    if (geometryType === "Point")
    {
        bounds.extend((geometry as google.maps.Data.Point).get());
        return;
    }

    if (geometryType === "MultiPoint" || geometryType === "LineString" || geometryType === "LinearRing")
    {
        (geometry as google.maps.Data.MultiPoint | google.maps.Data.LineString | google.maps.Data.LinearRing).getArray().forEach(function (item)
        {
            bounds.extend(item as google.maps.LatLng);
        });
        return;
    }

    if (geometryType === "Polygon" || geometryType === "MultiLineString" || geometryType === "GeometryCollection")
    {
        (geometry as google.maps.Data.Polygon | google.maps.Data.MultiLineString | google.maps.Data.GeometryCollection).getArray().forEach(function (item)
        {
            extendBoundsForGeometry(bounds, item as google.maps.Data.Geometry);
        });
        return;
    }

    if (geometryType === "MultiPolygon")
    {
        (geometry as google.maps.Data.MultiPolygon).getArray().forEach(function (item)
        {
            extendBoundsForGeometry(bounds, item);
        });
    }
}

function getFeatureProperties(feature: google.maps.Data.Feature): FranchiseMapFeatureProperties
{
    return {
        color: feature.getProperty("color"),
        franchiseId: feature.getProperty("franchiseId"),
        isDisabled: feature.getProperty("isDisabled"),
        name: feature.getProperty("name"),
        regionUrl: feature.getProperty("regionUrl"),
        subRegionUrl: feature.getProperty("subRegionUrl"),
        url: feature.getProperty("url")
    };
}

function getInfoWindowHtml(feature: FranchiseMapFeatureProperties)
{
    if (!feature.name)
    {
        return null;
    }

    let infoWindowHtml: string | null = null;

    const featureName = jQuery.trim(feature.name || "");

    jQuery(".location-areas-list > a, .location-areas-list > div.region-franchise").each(function (_, elem)
    {
        if (infoWindowHtml)
        {
            return false;
        }

        const htmlElem = elem as HTMLElement;

        let franchiseLabel = htmlElem.tagName === "A"
            ? jQuery(htmlElem).text()
            : jQuery(htmlElem).find("h3")?.text();

        franchiseLabel = jQuery.trim(franchiseLabel);

        if (franchiseLabel !== `Time For You ${featureName}` && franchiseLabel !== featureName)
        {
            return;
        }

        const phoneLink = htmlElem.dataset.phoneLink
            ? `<a href="${htmlElem.dataset.phoneLink}" class="phone-link"><i class="fa fa-phone"></i> ${htmlElem.dataset.phone}</a>`
            : "";

        const visitLabel = htmlElem.dataset.subHeader === "Region:" || htmlElem.dataset.subHeader === "County:"
            ? "Click here"
            : "View website";

        const sale = htmlElem.dataset.sale === "True";

        const visitLink = htmlElem.tagName === "A"
            ? (htmlElem as HTMLAnchorElement).href
            : htmlElem.dataset.href;

        const subHeader = sale
            ? ""
            : `<small>${htmlElem.dataset.subHeader}</small><br />`;

        const saleBadge = sale
            ? `<div class="sale-badge">For Sale</div>`
            : "";

        infoWindowHtml = `<div class="tfy-info-window"><h4>${subHeader}${franchiseLabel}</h4>${htmlElem.dataset.phoneLink ? phoneLink : ""}${saleBadge}<a href="${visitLink}" class="visit-link">${visitLabel} <i class="fa fa-angle-right fa-fw"></i></a></div>`;
        return false;
    });

    return infoWindowHtml;
}
